module.exports = __webpack_public_path__ + "static/bell-3ea1150c98fb72b18ccf9777e588a7cf.jpg";